import createAxiosInstance from "../LambdaApiStaff";
import { ENVIROMENT } from "../../utilities";

export async function GetFetchPersonal(body) {
  const axiosInstance = await createAxiosInstance();
  // TODO adicionar url de produccion real
  const url = ENVIROMENT === "dev" ? `/api/v1/requestcog/filter` : `/prod/api/v1/requestcog/filter`;
  const requestConfig = {
    method: "POST",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  };
  return axiosInstance(requestConfig);
}
